/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./downlinks.vue?vue&type=template&id=5549814b&scoped=true"
import script from "./downlinks.vue?vue&type=script&lang=js"
export * from "./downlinks.vue?vue&type=script&lang=js"
import style0 from "./downlinks.vue?vue&type=style&index=0&id=5549814b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5549814b",
  null
  
)

export default component.exports